/* eslint-disable no-unused-expressions */
import React, { useContext } from 'react'
import Context from '../../context'

export default function FormNavigation() {
  const { steps, setSteps } = useContext(Context)

  const handleBackStep = () => {
    steps.step > 1 && setSteps({ ...steps, step: steps.step - 1 })
  }

  const handleNextStep = () => {
    steps.step < steps.maxStep && setSteps({ ...steps, step: steps.step + 1 })
  }

  const handleGoStep = value => {
    if (value <= steps.maxStep || value >= 1) {
      setSteps({ ...steps, step: value })
    }
  }

  return (
    <div className="row justify-content-center fixed-bottom">
      <nav aria-label="Navigation Page">
        <ul className="pagination justify-content-center">
          <li className="page-item">
            {steps.step > 1 && (
              <button
                type="button"
                className="page-link clube-page-link"
                aria-label="Previous"
                onClick={handleBackStep}
              >
                <span aria-hidden="true">&laquo;</span>
              </button>
            )}
          </li>

          {Array.from({ length: steps.maxStep }, (_, index) => {
            return (
              <li key={index} className="page-item ">
                <button
                  onClick={() => handleGoStep(index + 1)}
                  type="button"
                  className={`page-link ${
                    steps.step === index + 1 ? 'clube-blue' : 'clube-page-link'
                  }`}
                >
                  {index + 1}
                </button>
              </li>
            )
          })}

          <li className="page-item">
            {steps.step < steps.maxStep && (
              <button
                type="button"
                className="page-link clube-page-link"
                aria-label="Next"
                onClick={handleNextStep}
              >
                <span aria-hidden="true">&raquo;</span>
              </button>
            )}
          </li>
        </ul>
      </nav>
    </div>
  )
}
